import { Controller } from "@hotwired/stimulus"
import { loadChoices } from "../utils/load_choices"

export default class extends Controller {
  static targets = ["select", "price", "overlay"]
  static values = {
    mobileBreakpoint: { type: Number, default: 639 }
  }

  async connect() {
    if (!this.hasSelectTarget) return

    this.ChoicesConstructor = await loadChoices()
    if (!this.isConnected) return

    this.initializeDropdown()
    this.initializeFirstCurrency()
    this.setupResponsiveHandling()
    this.setupCloseButton()
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy()
    }
    window.removeEventListener("resize", this.resizeHandler)
    document.removeEventListener("click", this.documentClickHandler)
  }

  initializeDropdown() {
    const Choices = this.ChoicesConstructor
    if (!Choices) return

    const choicesConfig = {
      allowHTML: true,
      searchEnabled: true,
      itemSelectText: "",
      searchPlaceholderValue: "Search"
    }

    const choicesData = this.createChoicesData()
    this.selectTarget.innerHTML = "" // Clear existing options
    this.choices = new Choices(this.selectTarget, {
      ...choicesConfig,
      choices: choicesData
    })

    this.selectTarget.addEventListener("change", this.changeCurrency.bind(this))

    this.selectTarget.addEventListener("showDropdown", () => this.isMobileView() && this.showOverlay())
    this.selectTarget.addEventListener("hideDropdown", () => this.isMobileView() && this.hideOverlay())
  }

  createChoicesData() {
    return Array.from(this.selectTarget.options).map((option, index) => ({
      value: option.value,
      label: option.text,
      selected: index === 1
    }))
  }

  initializeFirstCurrency() {
    if (this.selectTarget.options.length > 0) {
      this.currentCurrency = this.selectTarget.options[0].value
    }
  }

  setupResponsiveHandling() {
    this.resizeHandler = () => {
      if (!this.isMobileView()) this.hideOverlay()
    }
    window.addEventListener("resize", this.resizeHandler)

    this.documentClickHandler = event => {
      if (!this.isMobileView() || !this.hasOverlayTarget) return
      if (this.choices?.dropdown?.isActive) return

      const clickedOutside =
        this.choices && !this.choices.containerInner.element.contains(event.target) && !this.overlayTarget.classList.contains("hidden")

      if (clickedOutside) this.hideOverlay()
    }
    document.addEventListener("click", this.documentClickHandler)
  }

  changeCurrency() {
    this.currentCurrency = this.selectTarget.value

    if (this.hasPriceTarget) {
      this.priceTargets.forEach(element => {
        const isMatchingCurrency = element.dataset.currency === this.currentCurrency
        element.classList.toggle("hidden", !isMatchingCurrency)
      })
    }
  }

  isMobileView() {
    return window.innerWidth < this.mobileBreakpointValue
  }

  showOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
  }

  hideOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
  }

  setupCloseButton() {
    const closeButtonHandler = event => {
      const closeButtonArea = event.target

      if (
        closeButtonArea.classList.contains("mobile-dropdown-close") ||
        (closeButtonArea.tagName === "DIV" &&
          closeButtonArea.classList.contains("choices__list--dropdown") &&
          event.offsetX > closeButtonArea.offsetWidth - 70)
      ) {
        this.choices.hideDropdown()
        this.hideOverlay()
      }
    }

    document.addEventListener(
      "click",
      event => {
        if (!this.isMobileView()) return

        if (
          event.target.closest(".choices__list--dropdown::before") ||
          (event.target.closest(".choices__list--dropdown") && event.target.matches("div.choices__list--dropdown"))
        ) {
          closeButtonHandler(event)
        }
      },
      true
    )
  }
}
